import {
  createStudioIntegrationLessonDescriptionConfig,
  editStudioIntegrationLessonDescriptionConfig,
  getStudioIntegrationLessonDescriptionConfigDetail,
} from '../../../api/studioIntegrationConfigsApi'
import StudioIntegrationConfigForm from '../../../components/studio-integration-configs/studio-integration-config-form/studio-integration-config-form'
import translate from '../../../i18n'
import { ConfigType, IStudioIntegrationLessonDescriptionConfig } from '../share-types'
import { notification } from 'antd'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

dayjs.extend(customParseFormat)

const StudioIntegrationLessonDescConfigForm = () => {
  const navigation = useNavigate()
  const params = useParams()
  const [studioIntegrationConfigId] = useState<string | undefined>(params?.id)
  const [lessonDescConfigId] = useState<string | undefined>(params?.lessonDescConfigId)
  const [data, setData] = useState<IStudioIntegrationLessonDescriptionConfig>()

  useEffect(() => {
    if (lessonDescConfigId) {
      getStudioIntegrationLessonDescriptionConfigDetail(Number(lessonDescConfigId)).then(data => {
        setData(data)
      })
    }
  }, [lessonDescConfigId])

  const onSubmit = (data: any) => {
    if (lessonDescConfigId) {
      editStudioIntegrationLessonDescriptionConfig(Number(lessonDescConfigId), data)
        .then(() => {
          notification.success({
            title: translate('studioIntegrationConfig.editSuccess'),
          })
          navigation(`/studio-integration-config/${studioIntegrationConfigId}`)
        })
        .catch(err => {
          notification.error({
            title: translate('studioIntegrationConfig.editError'),
            description: err?.message || '网络请求失败，请稍后重试',
          })
        })
    } else {
      createStudioIntegrationLessonDescriptionConfig(data)
        .then(() => {
          notification.success({
            title: translate('studioIntegrationConfig.createSuccess'),
          })
          navigation(`/studio-integration-config/${studioIntegrationConfigId}`)
        })
        .catch(err => {
          notification.error({
            title: translate('studioIntegrationConfig.createError'),
            description: err?.message || '网络请求失败，请稍后重试',
          })
        })
    }
  }

  return (
    <>
      {studioIntegrationConfigId && (
        <StudioIntegrationConfigForm
          type={ConfigType.LESSON_DESCRIPTION}
          onSubmit={onSubmit}
          data={data}
          studioIntegrationConfigId={studioIntegrationConfigId}
        />
      )}
    </>
  )
}

export default StudioIntegrationLessonDescConfigForm
